<template>
    <footer class="footer-wrap">
        <div class="container">
            <div class="top-row">
                <div class="left-group">
                    <div class="nav-menu">
                        <div v-for="(item, index) in footerNav" @click="toList(item)" :key="index">
                            <span class="nav-item">{{ item.name }}</span>
                            <span class="divider" v-if="index !== footerNav.length - 1">·</span>
                        </div>
                    </div>
                    <div class="bottom-row">
                        <div class="address-box">
                            <img src="https://admin.syljhky.com//uploads/20260423/903a5ec8bf39c7d39a70198eb9b62e69.png"
                                alt="地址" class="addr-icon" />
                            <span class="text">{{ aboutObj.address }}</span>
                        </div>
                    </div>
                    <div class="website">
                        <div class="text">友情链接： </div>
                        <a href="https://wsfw.mva.gov.cn/#/index" target="_blank">全国一体化退役军人网上服务平台</a>
                    </div>
                </div>

                <div class="right-group">
                    <div class="hotline-box">
                        <p class="box-title">咨询热线</p>
                        <p class="phone-number">{{ aboutObj.phone }}</p>
                        <p class="service-desc">(全天24小时服务)</p>
                    </div>

                    <div class="contact-box">
                        <p class="box-title">联系我们</p>
                        <div class="icons">
                            <img src="https://admin.syljhky.com//uploads/20260423/dfa2d2f0cbef3dd1fbe875817d94be05.png"
                                alt="微信" class="wx-icon" />
                            <img :src="aboutObj.image" alt="二维码" class="qrcode" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    props: ['id'],
    data() {
        return {
            footerNav: [{ name: "首页", path: '/', text: "Home", id: 1 },
            { name: "集团业务", path: '/groupBusiness', text: "Group Business", id: 2 },
            { name: "集团新闻", path: '/groupNews', text: "Group News", id: 3 },
            { name: "专家团队", path: '/expertTeam', text: "Expert Team", id: 4 },
            { name: "关于我们", path: '/aboutUs', text: "About Us", id: 5 },],
            aboutObj: '',
        };
    },
    methods: {
        toList(item) {
            this.$router.push({
                path: item.path,
                query: {
                    id: item.id,
                }
            })
        },
        getAbout() {
            this.axios
                .post("/api/index/getAbout")
                .then((res) => {
                    this.aboutObj = res;
                    this.aboutObj.image = "https://admin.syljhky.com//" + this.aboutObj.image;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
    created() {
        this.getAbout();
    },
};
</script>

<style lang="scss" scoped>
.footer-wrap {
    width: 100%;
    background: url("https://admin.syljhky.com//uploads/20260423/7110cee7a83f47161bcb01d549defabb.png") no-repeat center center;
    background-size: cover;
    padding: 60px 0;
    color: #fff;
    font-size: 16px;

    .container {
        width: 55%;
        margin: 0 auto;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        gap: 12px;

        .top-row {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            .left-group {
                .nav-menu {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    margin-bottom: 40px;

                    .nav-item {
                        cursor: pointer;
                        font-weight: 600;
                        font-size: 17px;
                    }

                    .divider {
                        opacity: 0.7;
                    }
                }

                .website {
                    margin-top: 50px;
                    text-align: left;
                    display: flex;
                    align-items: center;

                    .text {
                        font-size: 15px;
                        font-weight: 600;
                        margin-right: 6px;
                    }

                    a {
                        color: white;
                        font-size: 15px;
                        font-weight: 600;
                    }
                }

                .bottom-row {
                    display: flex;
                    justify-content: space-between;

                    .address-box {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        font-size: 17px;
                        font-weight: 600;

                        .addr-icon {
                            width: 22px;
                            height: 22px;
                            object-fit: contain;
                        }
                    }
                }
            }

            .right-group {
                display: flex;
                gap: 60px;

                .hotline-box,
                .contact-box {
                    text-align: left;
                }

                .box-title {
                    margin-bottom: 30px;
                    padding-bottom: 4px;
                    font-size: 17px;
                    font-weight: 600;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
                }

                .phone-number {
                    font-size: 28px;
                    font-weight: bold;
                    padding-right: 20px;
                }

                .service-desc {
                    font-size: 14px;
                    opacity: 0.8;
                }

                .icons {
                    display: flex;
                    align-items: center;
                    gap: 40px;
                    padding-right: 20px;
                }

                .wx-icon {
                    width: 30px;
                    height: 30px;
                    object-fit: contain;
                }

                .qrcode {
                    width: 80px;
                    height: 80px;
                }
            }
        }
    }
}

@media (max-width: 1600px) {
    .footer-wrap .container {
        width: 70%;
        min-width: auto;
    }
}

@media (max-width: 1200px) {
    .footer-wrap .container {
        width: 85%;
    }
}

@media (max-width: 992px) {
    .footer-wrap .container {
        width: 90%;
    }

    .footer-wrap .container .top-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 40px;
    }

    .footer-wrap .right-group {
        width: 100%;
        justify-content: space-between;
        gap: 30px;
    }
}

@media (max-width: 768px) {
    .footer-wrap .right-group {
        flex-direction: column;
        gap: 40px;
    }

    .footer-wrap .nav-menu {
        flex-wrap: wrap;
    }
}

@media (max-width: 576px) {
    .footer-wrap {
        padding: 40px 0;
        font-size: 14px;
    }

    .footer-wrap .phone-number {
        font-size: 22px;
    }

    .footer-wrap .qrcode {
        width: 70px;
        height: 70px;
    }
}
</style>
